module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox-group"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.label) + "\n\t")]), _vm._v(" "), (_vm.tooltip && _vm.tooltip.text) ? _c('erco-tooltip', {
    attrs: {
      "variant": _vm.tooltip.variant,
      "title": _vm.tooltip.title,
      "text": _vm.tooltip.text
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "checkbox-container",
    class: _vm.containerClasses
  }, _vm._l((_vm.options), function(option, index) {
    return _c('b-form-checkbox', {
      key: index,
      staticClass: "checkbox",
      attrs: {
        "value": option.value,
        "unchecked-value": "",
        "disabled": option.disabled
      },
      on: {
        "change": function($event) {
          _vm.handleChange(index, option.value, $event)
        }
      },
      model: {
        value: (_vm.prepValue[index]),
        callback: function($$v) {
          var $$exp = _vm.prepValue,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            _vm.prepValue[index] = $$v
          } else {
            $$exp.splice($$idx, 1, $$v)
          }
        },
        expression: "prepValue[index]"
      }
    }, [_vm._v("\n\t\t\t" + _vm._s(option.text) + "\n\t\t")])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9ab08a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoCheckboxGroup.vue
// module id = 674
// module chunks = 0